export class UpdateBrokerIdRequest {
    constructor (
        public BrokerId: string = '',
    ) { }
}